export default __webpack_public_path__ + "2dfd7c1ae3166c02cb34da428ee60fab.png";